// Shopfloor — Help wiki articles (Uzbek)
// Each entry is a wiki page for one app section. Content is long-form Uzbek.

export interface HelpSection {
  heading: string
  body: string[]
}

export interface HelpArticle {
  slug: string
  title: string
  icon: 'book' | 'gauge' | 'clipboard' | 'boxes' | 'user' | 'chart' | 'clock' | 'handover'
  description: string
  sections: HelpSection[]
  tips?: string[]
}

export const helpArticles: HelpArticle[] = [
  {
    slug: 'general',
    title: 'Kirish',
    icon: 'book',
    description: 'Tizimga kirish, tilni tanlash va ruxsatlar haqida umumiy ma’lumot.',
    sections: [
      {
        heading: 'Tizimga kirish',
        body: [
          'Ilovani oching va elektron pochta hamda parolingiz bilan tizimga kiring.',
          'Agar hisobingizda ishlab chiqarish bo‘limiga ruxsat bo‘lmasa, tizim tegishli xabarni ko‘rsatadi.',
        ],
      },
      {
        heading: 'Tilni tanlash',
        body: [
          'Yon paneldagi til menyusidan O‘zbek, Rus yoki Ingliz tillarini tanlashingiz mumkin.',
          'Tanlangan til qurilmada saqlanadi va keyingi kirishda ham qo‘llaniladi.',
        ],
      },
      {
        heading: 'Ruxsatlar',
        body: [
          'Ro‘yxatlar va ko‘rinishlar “ko‘rish” ruxsatini, o‘zgartirishlar esa “boshqarish” ruxsatini talab qiladi.',
          'Bosqichni qayta ochish kabi maxsus amallar faqat rahbar (supervizor) hisoblari uchun ochiq.',
        ],
      },
    ],
    tips: ['Muammo yuz bersa, sahifani yangilang va qayta urinib ko‘ring.'],
  },
  {
    slug: 'dashboard',
    title: 'Smena paneli',
    icon: 'gauge',
    description: 'Ishlab chiqarishning umumiy holati, KPI ko‘rsatkichlari va to‘siqlar.',
    sections: [
      {
        heading: 'Umumiy ko‘rinish',
        body: [
          'Smena paneli ishlab chiqarishning joriy holatini bir qarashda ko‘rsatadi.',
          'KPI kartalari: faol buyurtmalar soni, rejalashtirilgan va ishlab chiqarilgan juftlar hamda bajarilish foizi.',
        ],
      },
      {
        heading: 'To‘siqlar (bottleneck)',
        body: [
          'To‘siqlar paneli eng past bajarilgan bosqichlarni ko‘rsatadi.',
          'Har bir to‘siqni bosganingizda buyurtma sahifasi ochiladi va muammoli bosqich belgilab ko‘rsatiladi.',
        ],
      },
      {
        heading: 'Xulosa panellari',
        body: [
          'Rad va qayta ishlash miqdorlari, ochiq bosqichlarga tayinlangan xodimlar soni ko‘rsatiladi.',
          'Ishlayotgan va bo‘sh turgan stanoklar soni ham shu yerda aks etadi.',
        ],
      },
    ],
    tips: ['To‘siqni tanlash orqali muammoli bosqichga tezda o‘ting.'],
  },
  {
    slug: 'orders',
    title: 'Faol buyurtmalar',
    icon: 'clipboard',
    description: 'Joriy bajarilayotgan ishlab chiqarish buyurtmalari ro‘yxati.',
    sections: [
      {
        heading: 'Ro‘yxat bilan ishlash',
        body: [
          'Sahifada barcha faol buyurtmalar jadval ko‘rinishida ko‘rsatiladi: kod, mahsulot, bo‘lim, reja va ishlab chiqarilgan miqdor, bajarilish foizi va holat.',
        ],
      },
      {
        heading: 'Qidiruv va filtr',
        body: [
          'Qidiruv maydoniga buyurtma kodi, mahsulot nomi yoki bo‘limni yozing.',
          'Holat filtri orqali jarayondagi, kutilayotgan yoki yakunlangan buyurtmalarni tanlang.',
        ],
      },
      {
        heading: 'Buyurtmani ochish',
        body: [
          'Qatordagi ko‘z (👁) ikonkasini bosing — buyurtmaning bosqichlar va partiyalar sahifasi ochiladi.',
        ],
      },
    ],
    tips: ['Qidiruv natijalari avtomatik ravishda yangilanadi.'],
  },
  {
    slug: 'order-detail',
    title: 'Buyurtma tafsilotlari',
    icon: 'boxes',
    description: 'Bosqichlar, partiyalar, bajarilishni qayd etish, yopish va qayta ochish.',
    sections: [
      {
        heading: 'Bosqichlar paneli',
        body: [
          'Buyurtmaning barcha bosqichlari ketma-ketlikda ko‘rsatiladi, har birining bajarilish foizi bilan.',
          'Yozuvlar ikonkasidan bosqich tarixini (bajarilish, yopish, qayta ochish) ko‘rishingiz mumkin.',
          'Ochiq bosqichni yopish uchun belgi (✓) ikonkasini bosing.',
          'Yopilgan bosqichni qayta ochish — rahbar ruxsati va sababni kiritishni talab qiladi.',
        ],
      },
      {
        heading: 'Partiya yaratish',
        body: [
          '“Partiya yaratish” tugmasini bosing, boshlang‘ich bosqich va miqdorni kiriting.',
          'Yangi partiya tanlangan bosqichdan boshlab harakatlanadi.',
        ],
      },
      {
        heading: 'Partiya tafsilotlari',
        body: [
          'Partiya qatoridagi ko‘z ikonkasini bosing — partiyaning bosqichlar bo‘yicha kuzatuvi va barcha harakatlar tarixi ochiladi.',
          '“Bajarilish” ikonkasidan bajarilgan, rad etilgan va qayta ishlash miqdorlarini qayd eting.',
        ],
      },
    ],
    tips: [
      'Bajarilishni qayd etishda xodimni tanlash majburiy.',
      'Bosqichni yopish uchun bajarilgan miqdor noldan katta bo‘lishi kerak.',
    ],
  },
  {
    slug: 'assignments',
    title: 'Taqsimotlar',
    icon: 'user',
    description: 'Xodim va stanoklarni buyurtma, bosqich va partiyalarga tayinlash.',
    sections: [
      {
        heading: 'Ko‘rinish',
        body: [
          '“Xodimlar” va “Stanoklar” bo‘limlari alohida ko‘rsatiladi.',
          'Smena filtri va “faqat faollari” belgisi orqali ro‘yxatni toraytiring.',
        ],
      },
      {
        heading: 'Taqsimot yaratish',
        body: [
          '“Taqsimot yaratish” tugmasini bosing.',
          'Turi (xodim yoki stanok), smena, buyurtma va bosqichni tanlang; buyurtma tanlanganida bosqichlar avtomatik yuklanadi.',
          'Xodim yoki stanok katalogdan tanlanadi, partiya esa buyurtma partiyalari ro‘yxatidan.',
        ],
      },
      {
        heading: 'Taqsimotni yakunlash',
        body: [
          'Faol taqsimot qatoridagi to‘xtatish (⏹) ikonkasini bosib uni yakunlaysiz.',
          'Yakunlangan taqsimot “Yakunlangan” holatiga o‘tadi.',
        ],
      },
    ],
    tips: ['Buyurtma tanlangandan so‘ng bosqich ro‘yxati avtomatik to‘ldiriladi.'],
  },
  {
    slug: 'output',
    title: 'Kunlik ishlab chiqarish',
    icon: 'chart',
    description: 'Sana bo‘yicha bosqich va xodim kesimida ishlab chiqarish miqdorlari.',
    sections: [
      {
        heading: 'Hisobotni ko‘rish',
        body: [
          'Sana tanlang — bosqichlar va xodimlar bo‘yicha bajarilgan, rad etilgan va qayta ishlangan miqdorlar ko‘rsatiladi.',
          'Bosqich yoki xodim filtri orqali ro‘yxatni toraytiring.',
        ],
      },
      {
        heading: 'Eksport',
        body: [
          '“CSV eksport” tugmasi bilan hisobotni fayl sifatida yuklab olishingiz mumkin.',
        ],
      },
    ],
    tips: ['Miqdorlar bosqich yozuvlari asosida avtomatik hisoblanadi.'],
  },
  {
    slug: 'downtime',
    title: 'To‘xtalishlar',
    icon: 'clock',
    description: 'To‘xtalish hodisalarini qayd etish, sabab va uskunani ko‘rsatish.',
    sections: [
      {
        heading: 'To‘xtalishni qayd etish',
        body: [
          '“To‘xtalishni qayd etish” tugmasini bosing.',
          'Sababni tanlang (sabablar mahalliylashtirilgan), uskunani ro‘yxatdan tanlang (yoki “uskuna yo‘q”) va boshlanish vaqtini kiriting.',
        ],
      },
      {
        heading: 'To‘xtalishni yopish',
        body: [
          'Ochiq to‘xtalish qatoridagi belgi (✓) ikonkasini bosing — yopilish vaqti qayd etiladi va davomiylik hisoblanadi.',
        ],
      },
      {
        heading: 'Filtrlash',
        body: [
          'Sabab filtri va “faqat ochiqlar” belgisi orqali ro‘yxatni boshqaring.',
        ],
      },
    ],
    tips: ['Bir stanok uchun bir vaqtda faqat bitta ochiq to‘xtalish bo‘lishi mumkin.'],
  },
  {
    slug: 'handover',
    title: 'Smena topshirish',
    icon: 'handover',
    description: 'Smena topshirish yozuvlari, topshirilgan buyurtmalar va muammolar.',
    sections: [
      {
        heading: 'Yozuv yaratish',
        body: [
          '“Smena topshirishni yaratish” tugmasini bosing.',
          'Smena, davr (dan/gacha), topshirilgan buyurtmalar soni va belgilangan muammolar sonini kiriting.',
          'Agar keyingi smena e’tiborini talab qiladigan holat bo‘lsa, “E’tibor talab etiladi” belgisini qo‘ying.',
        ],
      },
      {
        heading: 'Ro‘yxat',
        body: [
          'Barcha yozuvlar kartalar ko‘rinishida, umumiy xulosalar bilan ko‘rsatiladi.',
          'E’tibor talab qiladigan yozuvlar alohida belgilanadi.',
        ],
      },
    ],
    tips: ['Muammolar haqida izoh qoldirish keyingi smenaga yordam beradi.'],
  },
]

export function findHelpArticle(slug: string): HelpArticle | undefined {
  return helpArticles.find((article) => article.slug === slug)
}
